<template>
  <div>
    <Upload
      multiple
      type="drag"
      ref="nius"
      :on-success="success"
      :on-remove="remove"

      action="/api/upload/upload">
      <div style="padding: 20px 0">
        <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
        <p>批量上传文件，或将文件拖入到此处</p>
      </div>
    </Upload>
  </div>
</template>

<script>
  export default {
    props:{
      value:{
        type:Array,
        default:[]
      }
    },
    data(){
      return{
        list:[],
      }
    },
    methods:{
      success(response, file, fileList){
        this.list.push(response.upload);
        this.$emit('input',this.list);
      },
      remove(file, fileList){
        for(let i= 0;i<this.list.length;i++){
          if(this.list[i].subName===file.response.upload.subName){
            this.list.splice(i,1);
          }
        }
        this.$emit('input',this.list);
      }
    }

  }
</script>



// WEBPACK FOOTER //
// src/public/upload/UploadBuch.vue